export default "__VITE_ASSET__dJ8IdpG0__"